var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buildEdit"},[_c('a-row',[_c('a-col',{staticStyle:{"height":"100vh"},attrs:{"span":6}}),_c('a-col',{staticStyle:{"height":"100vh","border-left":"1px solid #ccc"},attrs:{"span":18}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }